import { useEffect, useState } from "react";
import { CaptionPosition, DEFAULT_CAPTION_POSITION } from "../../../types/captionPosition";

export interface UseCaptionPositionReturn {
    captionPosition: CaptionPosition;
    setCaptionPosition: (value: CaptionPosition) => void;
}

// Where a captioned video's captions sit, picked per piece. Every visit opens on Bottom: nothing
// is remembered between pieces, and a change of effective user (impersonation) starts over too.
export const useCaptionPosition = (
    effectiveUserId: string | null | undefined
): UseCaptionPositionReturn => {
    const [captionPosition, setCaptionPosition] = useState<CaptionPosition>(DEFAULT_CAPTION_POSITION);
    useEffect(() => {
        setCaptionPosition(DEFAULT_CAPTION_POSITION);
    }, [effectiveUserId]);
    return { captionPosition, setCaptionPosition };
};
